import React, { useEffect, useState } from 'react';
import { AppContext } from '../../../../../contexts/app';
import { UserContext } from '../../../../../contexts/user';
import { ico_check, ico_pen_alt, ico_plus, ico_times, ico_trash } from '../../../../../icon';
import Stylesheet from './Columns.module.css';
import {firestore} from '@enigma/core/services';
import Input from '../../../../../elements/Input/Input';
import DropMenu from '../../../../../elements/DropMenu/DropMenu';
import Checkbox from '../../../../../elements/Checkbox/Checkbox';
import Button from '../../../../../elements/Button/Button';
import Number from '../../../../../elements/Number/Number';
import { TableContext } from '../../../context/table';
import { QueryContext } from '../../../context/query';
import { useHistory } from 'react-router-dom';

const Forms = (props) => {
    const table = props.table;
    const metadata = table.metadata;
    const schema = table.schema;
    const app = props.app;
    const selectedColumn = props?.selectedColumn;
    const [title, setTitle] = useState(selectedColumn?.title || null);
    const [type, setType] = useState(selectedColumn?.type || 'string');
    const [unique, setUnique] = useState(selectedColumn?.unique || false);
    const [configuration, setConfiguration] = useState(selectedColumn?.configuration || null);
    const [loading, setLoading] = useState(false);
    const [refferenceList, setRefferenceList] = useState([]);
    useEffect(() => {
        setRefferenceList([]);
        setConfiguration(selectedColumn?.configuration || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])
    useEffect(() => {
        setTitle(selectedColumn?.title || null);
        setType(selectedColumn?.type || 'string');
        setUnique(selectedColumn?.unique || false);
        setConfiguration(selectedColumn?.configuration || null);
        setRefferenceList([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])
    const isConfigurationValid = _ => {
        if (type === "notify") {
            if (configuration?.daysBefore) return true;
            return false;
        } else if (type === "table refference" 
        || type === "form refference") {
            if (configuration?.refference) return true;
            return false;
        } else return true;
    }
    const add = _ => {
        if (!isConfigurationValid()) {
            app.toggleToast(ico_times, 
                'column configuration is empty', true);
            return;
        }
        firestore.doc(metadata.document).update({
            schema: firestore.fieldValue.arrayUnion({
                title: title,
                type: type,
                required: true,
                // make a unique property key for each column cell
                name: `${Date.now()}`,
                unique: unique,
                configuration: configuration
            })
        }).then(_ => app.toggleToast(ico_check, 'column successfully created'),
        _ => app.toggleToast(ico_times, 'column could not be created', true))
    }

    const update = _ => {
        const index = schema.findIndex(({name}) => selectedColumn.name === name);
        schema[index] = {
            title: title, 
            name: schema[index].name,
            type: type,
            required: true, 
            unique: unique,
            configuration: configuration
        }
        firestore.doc(metadata.document).update({
            schema: schema
        }).then(_ => app.toggleToast(ico_check, 'column successfully updated'),
        _ => app.toggleToast(ico_times, 'column could not be updated', true))
    }
    const addConfig = _ => {
        if (type === "notify") {
            return (
                <React.Fragment>
                    <h5 className={Stylesheet.Title}>notification</h5>
                    <div className={Stylesheet.Field}>
                        <Number min="7" max="365" 
                        defaultValue={configuration?.daysBefore}
                        placeholder='days before notification'
                        onChange={value => setConfiguration({daysBefore: value})} />
                    </div>
                </React.Fragment>
            )
        } else if (type === "table refference" 
        || type === "form refference") {
            const ref = type === "table refference"
            ? "tables" : "forms";
            if (!loading && refferenceList.length === 0) {
                setLoading(true);
                // get list of active tables
                firestore.collection(ref)
                .where("name", "!=", metadata.name).get()
                .then(snap => {
                    if (snap.empty) {
                        setRefferenceList([{name: ref === "tables" 
                        ? "no tables available" : "no forms available"}])
                        setLoading(false);
                        return;
                    }
                    let collection = [];
                    for (const table of snap.docs)
                        if (table.data()?.schema)
                            collection.push({
                                id: table.id, 
                                name: table.data()?.name, 
                                columns: table.data()?.schema
                            })
                    setRefferenceList(collection);
                    setLoading(false);
                })
            }
            return (
                <React.Fragment>
                    <h5 className={Stylesheet.Title}>select {ref}</h5>
                    <div className={Stylesheet.Field}>
                        <DropMenu 
                        disabled={props.operation !== "add"}
                        default={
                        refferenceList.length > 0 && configuration?.group
                        ? refferenceList.find(({id}) => id === configuration?.group)?.name
                        : null}
                        onChange={value => setConfiguration({
                            refference: `${ref}/${value.name}`, 
                            collection: ref,
                            group: value.id
                        })}
                        loading={loading} textProp="name"
                        values={refferenceList} />
                    </div>
                </React.Fragment>
            )
        } else return null;
    }
    return (
        <form className={Stylesheet.Form} onSubmit={event => {
        event.preventDefault(); 
        if (props.operation === "add") add(); else update(); }}>
            <h5 className={Stylesheet.Title}>column title</h5>
            <div className={Stylesheet.Field}>
                <Input placeholder='eg. first name' 
                defaultValue={title || null}
                onChange={value => setTitle(value)} />
            </div>
            <h5 className={Stylesheet.Title}>column type</h5>
            <div className={Stylesheet.Field}>
                <DropMenu default={type || null}
                disabled={props.operation !== "add"}
                onChange={value => setType(value)}
                values={["string", 
                "number", "date", 
                "file",
                "notify", "table refference"]} />
            </div>
            {addConfig()}
            <h5 className={Stylesheet.Title}>column settings</h5>
            <div className={Stylesheet.Field}>
                <Checkbox value={unique} 
                onChange={value => setUnique(value)} />
                <p>do not allow duplicated value</p>
            </div>
            <div className={Stylesheet.Controls}>
                <div className={Stylesheet.Control}>
                    <Button type='submit'>confirm</Button>
                </div>
            </div>
        </form>
    )
}

const Columns = (props) => {
    let history = useHistory();
    let app = null;
    let user = null;
    let table = null;
    let query = null;
    const init = (appContext, userContext, tableContext, queryContext) => {
        app = appContext;
        user = userContext;
        table = tableContext;
        query = queryContext;
    }
    const btnAddColumn = _ => {
        const privateColumnSelected = query?.selected.columns?.findIndex((name) => 
        name === 'id' || name === 'author' || name === 'timestamp') > -1;
        if (query?.selected.columns?.length === 0)
            return <Button onClick={_ => onAddColumn()} secondary
            disabled={query?.selected.records?.length > 0 
            || !user.profile?.admin
            || table?.config?.lock}>
            {ico_plus}&emsp;add column</Button>
        else if (query?.selected.columns?.length === 1)
            return <Button onClick={_ => onUpdateColumn()} 
            secondary disabled={privateColumnSelected 
            || !user.profile?.admin
            || table?.config?.lock}>
            {ico_pen_alt}&emsp;update column</Button>
        else return null;
    }
    const onAddColumn = _ => {
        const selectedColumn = table?.schema?.find(({name}) => 
        name === query?.selected.columns[0])
        app.togglePopup(null, 
        <Forms table={table} app={app}
        selectedColumn={selectedColumn}
        operation="add"/> , 'add new column'); 
    }
    const onDeleteColumn = async _ => {
        const response = await app.toggleMessageBox('confirm deletion', 
        `Are you sure you want to remove ${query?.selected.columns.length} columns ?.`+
        ' This can not be undone.', "yes_no");
        if (response === "yes") {
            let final = [];
            for (const column of table.schema) {
                if (!query.selected.columns.find((name) => name === column.name))
                    final.push(column);
            }
            firestore.doc(table.metadata.document)
            .update({schema: final})
            .then(_ => {
                history.push('?columns=')
                app.toggleToast(ico_check, "table schama updated")
            }, 
            _ => app.toggleToast(ico_times, "table schema could not be updated at this time", true))
        }
    }
    const onUpdateColumn = _ => {
        const selectedColumn = table?.schema?.find(({name}) => 
        name === query?.selected.columns[0])
        app.togglePopup(null, 
        <Forms table={table} app={app}
        selectedColumn={selectedColumn}
        operation="update" /> , `update '${selectedColumn.title}'`);
    }
    const content = config => {
        const privateColumnSelected = query?.selected.columns?.findIndex((name) => 
        name === 'id' || name === 'author' || name === 'timestamp') > -1;
        if (!config?.custom) return null;
        return (
            <div className={Stylesheet.ColumnGroup}>
                <div className={Stylesheet.Group}>
                    <h5 className={Stylesheet.Title}>manage column</h5>
                    {btnAddColumn()}
                    <Button onClick={_ => onDeleteColumn()}
                    disabled={query?.selected.columns?.length === 0 
                    || privateColumnSelected
                    || !user.profile?.admin
                    || config?.lock} secondary error>
                    {ico_trash}&emsp;delete column</Button>
                </div>
                <div className={Stylesheet.Group}>
                    <h5 className={Stylesheet.Title}>toggle columns</h5>
                    <div className={Stylesheet.Checkbox}>
                        <Checkbox value={config.disableID} onChange={value => {
                        const current = config;
                        current.disableID = value;
                        query.setConfig(current);}} /> 
                        <h5 className={Stylesheet.Text}>hide record ID</h5>
                    </div>
                    <div className={Stylesheet.Checkbox}>
                        <Checkbox value={config.disableAuthor} onChange={value => {
                        const current = config;
                        current.disableAuthor = value;
                        query.setConfig(current);}} /> 
                        <h5 className={Stylesheet.Text}>hide record author</h5>
                    </div>
                    <div className={Stylesheet.Checkbox}>
                        <Checkbox value={config.disableTimestamp} onChange={value => {
                        const current = config;
                        current.disableTimestamp = value;
                        query.setConfig(current);}} /> 
                        <h5 className={Stylesheet.Text}>hide record timestamp</h5>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <AppContext.Consumer>
            {app => (
                <UserContext.Consumer>
                    {user => (
                        <TableContext.Consumer>
                            {table => (
                                <QueryContext.Consumer>
                                    {query => (
                                        <div className={Stylesheet.Container}>
                                            {init(app, user, table, query)}
                                            {content(table.config)}
                                        </div>  
                                    )}
                                </QueryContext.Consumer>
                            )}
                        </TableContext.Consumer>
                    )}
                </UserContext.Consumer>
            )}
        </AppContext.Consumer>
    )
}

export default Columns;